;
define("global_views_host_selector.tpl", function(){});

